import { Component } from '@angular/core';
import {Params} from "../../params";
import * as moment from "moment";
import * as firebase from "firebase/app";
import {FindCustomerComponent} from "../../../components/find-customer/find-customer";
import {AlertController, LoadingController, ModalController} from "ionic-angular";
import {GlobalProvider} from "../../../providers/global/global";

@Component({
  selector: 'page-charges',
  templateUrl: 'charges.html',
})
export class ChargesPage {
  orders = [];
  items = [];
  month;
  year;
  years = [];
  money = Params.money;
  constructor(
    private modalCtrl : ModalController,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {
    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChargesPage');
    this.load();
  }

  link(c){
    const prompt = this.alertCtrl.create({
      title: 'Link para cliente '+c.customer.name,
      subTitle: 'https://admin.fitfood.cl/pay/'+c.id
    })
    prompt.present();
  }

  refresh(c){
    console.log(c);
  }

  create(){
    let modal = this.modalCtrl.create(FindCustomerComponent);
    modal.present();
    modal.onDidDismiss((customer) => {
      if (customer) {
        const prompt2 = this.alertCtrl.create({
          title: 'Generar cobro a ' + customer.name,
          inputs: [
            {
              type: 'checkbox',
              label: 'Bespin',
              value: 'value2'
            },
          ],
          buttons: [
            {
              text: 'Cancelar',
              handler: data => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Siguiente',
              handler: data => {
                let charge = {
                  customer: {
                    code: Params.md5(customer.email),
                    name: customer.name + ' ' + customer.lastname,
                    email: customer.email
                  },
                  amount: data.amount,
                  status: 'pending',
                  type: 'manual',
                  created_at: firebase.firestore.FieldValue.serverTimestamp(),
                  transactions: [],
                  description: "Pago Manual"
                }
                console.log('charge', charge);
                /*
                firebase.firestore().collection('charges')
                  .add()
                  .then(()=>this.load()) */
              }
            }
          ]
        })
        const prompt = this.alertCtrl.create({
          title: 'Generar cobro a '+customer.name,
          inputs: [
            {
              name: 'amount',
              placeholder: 'Monto',
              type: "number"
            },
          ],
          buttons: [
            {
              text: 'Cancelar',
              handler: data => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Siguiente',
              handler: data1 => {
                const prompt2 = this.alertCtrl.create({
                  title: 'Generar cobro a ' + customer.name,
                  inputs: [
                    {
                      type: 'checkbox',
                      label: '¿Emitir boleta?',
                      value: 'invoice',
                      checked: true
                    }
                  ],
                  buttons: [
                    {
                      text: 'Cancelar',
                      handler: data => {
                        console.log('Cancel clicked');
                      }
                    },
                    {
                      text: 'Siguiente',
                      handler: data2 => {
                        let charge = {
                          customer: {
                            code: Params.md5(customer.email),
                            name: customer.name + ' ' + customer.lastname,
                            email: customer.email
                          },
                          amount: data1.amount,
                          invoice: !!data2.length,
                          status: 'pending',
                          type: 'manual',
                          created_at: firebase.firestore.FieldValue.serverTimestamp(),
                          transactions: [],
                          description: "Pago Manual"
                        }
                        console.log('charge', charge);

                        firebase.firestore().collection('charges')
                          .add(charge)
                          .then(()=>this.load())
                      }
                    }
                  ]
                })
                prompt2.present()
              }
            }
          ]
        });
        prompt.present();
      }
    })
  }

  statusName(status){
    let st = 'n/a';
    if(status == 'on-hold') st = 'En Espera';
    if(status == 'processed') st = 'Procesado';
    if(status == 'pending') st = 'Pendiente';
    if(status == 'cancelled') st = 'Cancelado';
    if(status == 'failed') st = 'Fallido';
    return st;
  }

  statusColor(status){
    let st = 'n/a';
    if(status == 'on-hold') st = 'light';
    if(status == 'processed') st = 'secondary';
    if(status == 'pending') st = 'dark';
    if(status == 'cancelled') st = 'dark';
    if(status == 'failed') st = 'danger';
    return st;
  }

  fromNow(date){
    return moment(date.seconds * 1000).format('DD-MM-YY HH:mm:ss');
  }

  load(){
    console.log('load');
    let loading = this.loadingCtrl.create({
      content : "Espere porfavor"
    })
    loading.present();

    firebase.firestore().collection('charges')
      .where('created_at', '>', moment(this.year+'-'+this.month+'-15').startOf('month').toDate())
      .where('created_at', '<', moment(this.year+'-'+this.month+'-15').endOf('month').toDate())
      .orderBy("created_at", "desc")
      .get()
      .then((snap)=>{
        const orders = [];
        snap.forEach((x) => {
          const t = { id : x.id, period: this.year + this.month, ... x.data() };
          orders.push(t);
        });
        this.orders = orders;
        console.log(orders);
        this.initializeItems();
        loading.dismiss();
      })
  }

  initializeItems() {
    this.items = this.orders;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.customer.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.customer.email.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/pay/charges/charges.ts